import { makeObservable, observable, action } from 'mobx'

class Notification {

    error = null

    constructor() {
        makeObservable( this, {
            setError: action,
            error: observable
        } )
    }

    setError( error ) {
        this.error = error;
        setTimeout( () => {
            this.error = null;
        }, 3000)
    }

}


export default new Notification()
